import React from 'react';
import {Grid, Hidden} from '@material-ui/core';
import PendingCourses from 'features/dashboard/components/PendingCourses';
import {i18n2} from 'features/i18n/i18n';

const CoursesStatus = ({cwid, status, courseCount}) => {
  return (
    <Grid container spacing={3} style={{marginTop: '10px'}}>
      <Hidden xsDown>
        <Grid item sm={4} xs={12} key={1}>
          <PendingCourses
            cwid={cwid}
            status={status.notStarted}
            title={i18n2._('Not yet started')}
          />
        </Grid>
        <Grid item sm={4} xs={12} key={2}>
          <PendingCourses
            cwid={cwid}
            status={status.inProgress}
            title={i18n2._('In progress')}
          />
        </Grid>
        <Grid item sm={4} xs={12} key={3}>
          <PendingCourses
            cwid={cwid}
            status={status.finished}
            title={i18n2._('Completed')}
          />
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid item sm={4} xs={12} key={4}>
          <PendingCourses
            cwid={cwid}
            status={status.notStarted}
            title={i18n2._('Not yet started')}
            mobile
            count={courseCount.notStarted}
          />
        </Grid>
        <Grid item sm={4} xs={12} key={5}>
          <PendingCourses
            cwid={cwid}
            status={status.inProgress}
            title={i18n2._('In progress')}
            mobile
            count={courseCount.inProgress}
          />
        </Grid>
        <Grid item sm={4} xs={12} key={6}>
          <PendingCourses
            cwid={cwid}
            status={status.finished}
            title={i18n2._('Completed')}
            mobile
            count={courseCount.finished}
          />
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default CoursesStatus;
